import type { DependencyList } from 'react';
import { useEffect, useRef } from 'react';

const useFocusOnMount = (dependencies: DependencyList = []) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, dependencies);

  return inputRef;
};

export default useFocusOnMount;
